import React from 'react'
import MaterialTabs from '@material-ui/core/Tabs'
import MaterialTab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const AntTabs = withStyles({
    root: {
        // style for root element
    },

    indicator: {
        backgroundColor: 'var(--rox-lilac)',
        height: 2,
    },
})(MaterialTabs);

const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 50,
        // marginRignt: 20,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),

        fontFamily: theme.typography.fontFamily,
        fontSize: 'var(--t-body)',
        color: 'var(--fg-secondary)',
        '&:hover': {
            color: 'var(--fg-default)',
            opacity: 1,
        },
        '&$selected': {
            color: 'var(--fg-primary)',
            fontWeight: 600,
        },
        '&:focus': {
            color: 'var(--fg-default)',
        },
    },
    selected: {},
}))((props) => <MaterialTab disableRipple {...props} />);

const Tabs = (props) => {
    const {
        value,
        onChange,
        data = [],
        children,
        scrollable,
    } = props
    return (
        <AntTabs
            value={value}
            indicatorColor='primary'
            textColor='primary'
            onChange={onChange}
            aria-label='disabled tabs example'
            variant={scrollable ? "scrollable" : undefined}
            scrollButtons={scrollable ? "auto" : undefined}
        >
            {
                data.map((item, index) => {
                        return <AntTab {...item} key={index} />
                })
            }
            {children}
        </AntTabs>
    )
}

const Tab = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (children)}
        </div>
    );
}

Tabs.propTypes = {
    scrollable: PropTypes.bool,
}

export {
    Tabs,
    Tab
}